<div style="display: none;">
  <button (click)="test()">Test</button>
</div>